import { paths } from '@luxuryescapes/contract-svc-merchandise'
import { arrayToObject } from 'lib/array/arrayUtils'

type Response = paths['/api/merchandise/categories']['get']['responses']['200']['content']['application/json']
type ServerCategory = Response['result']['categories'][0]

function getOrderedAncestorIds(ancestors: ServerCategory['ancestors']): Array<string> {
  if (!ancestors.length) {
    return []
  }

  const ancestorsByParentId = arrayToObject(ancestors, ancestor => ancestor.parentId ?? 'top')
  let currentAncestor = ancestorsByParentId.top
  const orderedAncestorIds: Array<string> = [currentAncestor.id]
  while (ancestorsByParentId[currentAncestor.id]) {
    currentAncestor = ancestorsByParentId[currentAncestor.id]
    orderedAncestorIds.unshift(currentAncestor.id)
  }

  return orderedAncestorIds
}

function mapMerchandiseCategory(serverCategory: ServerCategory): App.MerchandiseCategory {
  return {
    id: serverCategory.id,
    parentId: serverCategory.parentId ?? undefined,
    name: serverCategory.displayName,
    level: serverCategory.ancestors.length + 1,
    slug: serverCategory.slug,
    ancestorIds: getOrderedAncestorIds(serverCategory.ancestors),
    childCategoryIds: serverCategory.subCategories.map(subCategory => subCategory.id),
    image: serverCategory.displayImageId ? {
      id: serverCategory.displayImageId,
      title: serverCategory.displayName,
    } : undefined,
  }
}

export default mapMerchandiseCategory
